import { Field } from '@payaca/ambrosia';
import { get as _get } from 'lodash-es';
import { FC } from 'react';
import type { Props as DyanmicFieldProps } from './DynamicField';
import FieldSet from './FieldSet';
import { getSchemaDataForDiscriminatorField } from './utils/devices';
import { getFieldLabelFromFieldSchema } from './utils/display';

type Props = Omit<DyanmicFieldProps, 'dependentFields'> & {
  formData: any;
};
const DiscriminatorFieldReadOnly: FC<Props> = (props) => {
  const { definitions, fieldSchema, name: namespace, formData } = props;
  // discriminator object containing property and mapping refs
  const discriminatorObj = fieldSchema.anyOf[0].discriminator;

  // name of discriminator property
  const discriminatorPropertyName = discriminatorObj.propertyName;

  // name for the nested field
  const nestedName = `${namespace}.${discriminatorPropertyName}`;

  // get the value of the discriminator property
  const discriminatorPropertyValue = _get(formData, nestedName);

  // get the nested schema for the selected discriminator value
  const nestedSchemaData = getSchemaDataForDiscriminatorField(
    discriminatorObj,
    definitions,
    discriminatorPropertyValue
  );

  const fieldLabel = getFieldLabelFromFieldSchema(fieldSchema);

  return (
    <>
      <Field.Legacy>
        <Field.Label>{fieldLabel}</Field.Label>
        <p>{discriminatorPropertyValue}</p>
      </Field.Legacy>

      {/* conditional fields based on discriminator */}
      {nestedSchemaData && (
        <FieldSet
          namespace={namespace}
          formSection={nestedSchemaData}
          definitions={definitions}
          readonly
          formData={formData}
        />
      )}
    </>
  );
};

export default DiscriminatorFieldReadOnly;
